import "../styles/app.css";

import { init as initOffcanvas } from "./modules/offcanvas.js";
import { init as initDropdown } from "./modules/dropdown.js";
import { init as initAccordion } from "./modules/accordion.js";
import { init as initReveal } from "./modules/reveal.js";
import { init as initLightbox } from "./modules/lightbox.js";
import { init as initPrefetch } from "./modules/prefetch.js";
import { init as initCounter } from "./modules/counter.js";
import { init as initProjectsFilter } from "./modules/projects-filter.js";
import { initProjectMap, initTravelMap } from "./modules/svg-map.js";
import { init as initProjectCounter } from "./modules/project-counter.js";
import { init as initTravelHub } from "./modules/travel-hub.js";
import { init as initReadingProgress } from "./modules/reading-progress.js";
import { init as initGalleryReveal } from "./modules/galleryReveal.js";
import "./modules/before-after.js"; // IIFE — auto-init + MutationObserver

const ready = (fn) => {
  if (document.readyState !== "loading") fn();
  else document.addEventListener("DOMContentLoaded", fn, { once: true });
};

ready(() => {
  document.documentElement.classList.add("js");
  initOffcanvas();
  initDropdown();
  initAccordion();
  initReveal();
  initLightbox();
  initPrefetch();
  initCounter();
  initProjectsFilter();
  initProjectMap();
  initProjectCounter();
  initTravelMap();
  initTravelHub();
  initReadingProgress();
  initGalleryReveal();
});
